/**
 * Accordion - 手风琴展开/折叠（同一时间只能展开一个面板）
 */
var Accordion = {
  toggle: function (trigger) {
    var item = trigger.closest('.acc-item');
    if (!item) return;

    var parent = item.parentElement;
    var content = item.querySelector('.acc-content');
    var icon = trigger.querySelector('.acc-icon');
    if (!content) return;

    var isOpen = item.classList.contains('open');

    // 先关闭同一容器内所有其他已打开的面板
    var siblings = parent.querySelectorAll('.acc-item.open');
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] === item) continue;
      Accordion._close(siblings[i]);
    }

    if (isOpen) {
      Accordion._close(item);
    } else {
      Accordion._open(item);
    }
  },

  _open: function (item) {
    var trigger = item.querySelector('.acc-trigger');
    var content = item.querySelector('.acc-content');
    var icon = trigger ? trigger.querySelector('.acc-icon') : null;
    if (!content) return;

    item.classList.add('open');
    content.style.height = content.scrollHeight + 'px';
    if (icon) icon.style.transform = 'rotate(180deg)';

    var handler = function () {
      if (item.classList.contains('open')) {
        content.style.height = 'auto';
      }
      content.removeEventListener('transitionend', handler);
    };
    content.addEventListener('transitionend', handler);
  },

  _close: function (item) {
    var trigger = item.querySelector('.acc-trigger');
    var content = item.querySelector('.acc-content');
    var icon = trigger ? trigger.querySelector('.acc-icon') : null;
    if (!content) return;

    content.style.height = content.scrollHeight + 'px';
    content.offsetHeight; // 强制 reflow
    content.style.height = '0px';
    item.classList.remove('open');
    if (icon) icon.style.transform = 'rotate(0deg)';
  }
};
